export function getCdSearchRedirect(searchTerm: string) {
  return `/casting/performers?performerName=${searchTerm}`;
}
